import { render, staticRenderFns } from "./NotarizationNumber.vue?vue&type=template&id=1dbfb2e6&scoped=true&"
import script from "./NotarizationNumber.vue?vue&type=script&lang=js&"
export * from "./NotarizationNumber.vue?vue&type=script&lang=js&"
import style0 from "./NotarizationNumber.vue?vue&type=style&index=0&id=1dbfb2e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbfb2e6",
  null
  
)

export default component.exports